'use client'

import { createContext, useContext, useState, type ReactNode } from 'react'

interface SearchContextValue {
  /** Si el panel/menú de búsqueda global está abierto. */
  menuOpen: boolean
  /** Abre/cierra el panel de búsqueda. */
  setMenuOpen: (open: boolean) => void
}

const SearchContext = createContext<SearchContextValue | null>(null)

export function SearchProvider({ children }: { children: ReactNode }) {
  const [menuOpen, setMenuOpen] = useState(false)
  return <SearchContext.Provider value={{ menuOpen, setMenuOpen }}>{children}</SearchContext.Provider>
}

export function useSearchContext(): SearchContextValue {
  const ctx = useContext(SearchContext)
  if (!ctx) {
    throw new Error('useSearchContext debe usarse dentro de <SearchProvider>.')
  }
  return ctx
}
